import { mainSiteUrl } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20walk-in%20closet%20interior%20with%20wooden%20shelves%20displaying%20neatly%20folded%20sweaters%20and%20handbags%2C%20open%20drawer%20with%20organized%20accessories%2C%20warm%20indoor%20lighting%20from%20ceiling%20spotlights%2C%20modern%20luxury%20apartment%20interior%20design%2C%20organized%20and%20sophisticated%20wardrobe%20photography&width=800&height=1000&seq=about-v2-01&orientation=portrait"
                alt="Kakobuy Spreadsheet - baza produktów"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-5">
              Kakobuy Sheet Guide
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              Czym jest
              <br />
              <span className="text-primary-500">Kakobuy Spreadsheet?</span>
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-4">
              <strong>Kakobuy Spreadsheet</strong> to kompleksowa baza danych produktów, stworzona z myślą o osobach, które cenią sobie szybkie i wygodne zakupy online. Jest to starannie zorganizowany arkusz zawierający setki sprawdzonych produktów z różnych kategorii — od obuwia i odzieży, przez akcesoria, aż po elektronikę.
            </p>
            <p className="text-base text-foreground-600 leading-relaxed mb-4">
              Dzięki <strong>Kakobuy Spreadsheet</strong> nie musisz już spędzać godzin na przeszukiwaniu dziesiątek stron. Wszystkie najlepsze znaleziska (tzw. <em>finds</em>) są zebrane w jednym miejscu, posegregowane według kategorii i regularnie aktualizowane. To idealne narzędzie zarówno dla początkujących, jak i doświadczonych kupujących.
            </p>
            <p className="text-base text-foreground-600 leading-relaxed mb-8">
              Arkusz <strong>Kakobuy</strong> pozwala zaoszczędzić czas, porównać produkty i podejmować lepsze decyzje zakupowe. Każdy wpis zawiera link do produktu, dzięki czemu jednym kliknięciem przejdziesz do szczegółów oferty.
            </p>

            <a
              href="/artykul/kakobuy-sheet-kompletny-przewodnik"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-lg bg-background-50 border border-background-300/60 text-foreground-800 text-sm font-semibold hover:bg-background-200 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
            >
              Czytaj pełny przewodnik
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>

            <div className="mt-8 pt-6 border-t border-background-200/70">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">Więcej poradników</p>
              <div className="flex flex-wrap gap-2">
                <a href="/artykul/cssbuy-spreadsheet-vs-kakobuy" className="px-4 py-2 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-all whitespace-nowrap cursor-pointer">
                  CSSBuy vs Kakobuy
                </a>
                <a href="/artykul/superbuy-spreadsheet-przewodnik" className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium hover:bg-secondary-200 transition-all whitespace-nowrap cursor-pointer">
                  Superbuy Spreadsheet
                </a>
                <a href="/artykul/oopbuy-spreadsheet-przewodnik" className="px-4 py-2 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-all whitespace-nowrap cursor-pointer">
                  Oopbuy Spreadsheet
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}